// PERMISSIONS
export const PERMISSION_NEW_SHADER = 'PERMISSION_NEW_SHADER';
export const PERMISSION_ADMIN_OWNER = 'PERMISSION_ADMIN_OWNER';
export const PERMISSION_OWNER = 'PERMISSION_OWNER';
export const PERMISSION_ADMIN = 'PERMISSION_ADMIN';
